import { Box, IconButton } from "@mui/material";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import AgricultureOutlined from "@mui/icons-material/AgricultureOutlined";
import { formatDate } from "../../utils/formatDate";
import { getHarvestTypeByValue, getLoteTypeByValue } from "../../constants/enums";

const lotesColumns = (handleSeeApplications, handleView, handleEdit, handleDelete, colors) => [
  {
    field: "name",
    headerName: "Nombre",
    flex: 1,
    cellClassName: "name-column--cell",
  },
  {
    field: "number",
    headerName: "Número",
    type: "number",
    headerAlign: "left",
    align: "left",
    flex: 1,
  },
  {
    field: "sowing_date",
    headerName: "Fecha de siembra",
    headerAlign: "left",
    align: "left",
    flex: 1,
    valueFormatter: (value) => formatDate(value),
  },
  {
    field: "plants",
    headerName: "Plantas",
    type: "float",
    headerAlign: "left",
    align: "left",
    flex: 0.8,
  },
  {
    field: "area",
    headerName: "Area",
    type: "float",
    headerAlign: "left",
    align: "left",
    flex: 0.8,
  },
  {
    field: "type",
    headerName: "Semilla",
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params) => {
      const typeInfo = getLoteTypeByValue(params.value);
  
      return (
        <Box
          sx={{
            color: typeInfo.color,
            fontWeight: "bold",
            backgroundColor: `${typeInfo.color}30`, // Transparent background
            border: ` ${typeInfo.color}`, // Corner borders
            borderRadius: "8px", // Rounded corners
            padding: "8px",
            display: "inline-flex",
            justifyContent: "center",
            alignItems: "center",
            width: "50%",
            height: "50%",
            textShadow: `0 0 30px ${typeInfo.color}`, // Shiny text effect
            overflow: "hidden", // Prevent shadow from going outside the box
          }}
        >
          {typeInfo.label}
        </Box>
      );
    },
  },
  {
    field: "harvest_tag",
    headerName: "Cosecha",
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params) => {
      const typeInfo = getHarvestTypeByValue(params.value);
  
      return (
        <Box
          sx={{
            color: typeInfo.color,
            fontWeight: "bold",
            backgroundColor: `${typeInfo.color}30`, // Transparent background
            border: ` ${typeInfo.color}`, // Corner borders
            borderRadius: "8px", // Rounded corners
            padding: "8px",
            display: "inline-flex",
            justifyContent: "center",
            alignItems: "center",
            width: "50%",
            height: "50%",
            textShadow: `0 0 30px ${typeInfo.color}`, // Shiny text effect
            overflow: "hidden", // Prevent shadow from going outside the box
          }}
        >
          {typeInfo.label}
        </Box>
      );
    },
  },
  {
    field: "actions",
    headerName: "Acciones",
    headerAlign: "center",
    flex: 1.2,
    renderCell: (params) => (
      <Box display="flex" alignItems="center" justifyContent="center" gap="10px">
        <IconButton onClick={() => handleSeeApplications(params.row.id)} sx={{ color: colors.grey[100] }}>
          <AgricultureOutlined />
        </IconButton>
        <IconButton onClick={() => handleView(params.row.id)} sx={{ color: colors.grey[100] }}>
          <VisibilityOutlinedIcon />
        </IconButton>
        <IconButton onClick={() => handleEdit(params.row.id)} sx={{ color: colors.grey[100] }}>
          <EditOutlinedIcon />
        </IconButton>
        <IconButton onClick={() => handleDelete(params.row.id)} sx={{ color: colors.grey[100] }}>
          <DeleteOutlinedIcon />
        </IconButton>
      </Box>
    ),
  },
];

export { lotesColumns };
